import { AbstractControl, ValidationErrors } from '@angular/forms';

export const Satisfies =
  (satisfiesFn: () => ValidationErrors | null) =>
  (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const satisfied = satisfiesFn();
    return satisfied;
  };